<template>
  <div class="checkin-records-page">
    <div v-if="!state.isLogin" class="login-tips">
      <van-empty description="请先登录后查看入住记录" />
    </div>

    <div v-else>
      <div class="fixed-info" v-if="state.roomNo || state.bedNo || state.sexName || state.bedPositionName">
        <div class="info-item"><span class="label">房间号</span><span class="value">{{ state.roomNo || '--' }}</span></div>
        <div class="info-item"><span class="label">床号</span><span class="value">{{ state.bedNo || '--' }}</span></div>
        <div class="info-item"><span class="label">性别</span><span class="value">{{ state.sexName || '--' }}</span></div>
        <div class="info-item"><span class="label">床位位置</span><span class="value">{{ state.bedPositionName || '--' }}</span></div>
      </div>
      <div class="content">
        <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
          <van-list
            v-model:loading="state.loading"
            :finished="state.finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div v-if="!state.records.length && !state.loading" class="empty-wrap">
              <van-empty description="暂无记录" />
            </div>
            <div v-for="(item, idx) in state.records" :key="item.id || idx" class="record-card">
              <div class="row">
                <div class="label">姓名</div>
                <div class="value status">{{ item.realName || '--' }}</div>
              </div>
              <div class="row">
                <div class="label">入住时间</div>
                <div class="value status">{{ dayjsFormat(item.checkInDate) || '--' }}</div>
              </div>
              <div class="row">
                <div class="label">到期时间</div>
                <div class="value status">{{ dayjsFormat(item.expireDate) || '--' }}</div>
              </div>
              <div class="row">
                <div class="label">关联产品</div>
                <div class="value status">{{ item.businessName || '--' }}</div>
              </div>
              <div class="row">
                <div class="label">入住状态</div>
                <div class="value status">{{ checkInStatusName(item.checkInStatus) }}</div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { bedUserSelectPage } from '@/api/user';
import dayjs from 'dayjs';

export default defineComponent({
  name: 'CheckinRecords',
  setup() {
    const route = useRoute();
    const state = reactive({
      isLogin: false,
      loading: false,
      refreshing: false,
      finished: false,
      pageNo: 1,
      pageSize: 10,
      records: [],
      bedId: null,
      roomNo: '',
      bedNo: '',
      sexName: '',
      bedPositionName: '',
    });

    const fetchList = async (reset = false) => {
      if (!localStorage.getItem('token') || !localStorage.getItem('userInfo')) {
        state.isLogin = false;
        return;
      }
      if (reset) {
        state.pageNo = 1;
        state.finished = false;
        state.records = [];
      }
      try {
        state.loading = true;
        const params = {
          pageNum: state.pageNo,
          pageSize: state.pageSize,
          bedId: state.bedId,
        };
        const res = await bedUserSelectPage(params);
        if (res && res.code === '00') {
          const list = res.data.list || [];
          state.records.push(...list);
          const total = res.data?.total ?? list.length;
          if (state.records.length >= total || list.length < state.pageSize) {
            state.finished = true;
          } else {
            state.pageNo += 1;
          }
        } else {
          state.finished = true;
        }
      } finally {
        state.loading = false;
        state.refreshing = false;
        state.isLogin = !!(localStorage.getItem('token') && localStorage.getItem('userInfo'));
      }
    };

    const onLoad = async () => {
      if (!state.finished) await fetchList();
    };

    const onRefresh = async () => {
      await fetchList(true);
    };

    const dayjsFormat = (date, format = 'YYYY-MM-DD') => dayjs(date).format(format);

    const lockDays = (checkInDate, expireDate) => {
      const date1 = new Date(checkInDate.slice(0,10))
      const date2 = new Date(expireDate.slice(0,10))
      const dayDiff = Math.abs(date1.getTime() - date2.getTime()) / (1000*3600*24)
      return Math.ceil(dayDiff) + 1
    }

    const signStatusName = (status) => {
      const temp = {1:"签约中", 2:"已到期", 3:"已中止", 4: "已作废"}
      return temp[status] || '--'
    }

    const checkInStatusName = (status) => {
      const temp = {1: "待入住", 2: "已入住", 3: "已终止", 4: "已取消", 5: "已到期"}
      return temp[status] || '--'
    }

    onMounted(async () => {
      state.isLogin = !!(localStorage.getItem('token') && localStorage.getItem('userInfo'));
      state.bedId = Number(route.query.bedId) || route.query.bedId || null;
      state.roomNo = route.query.roomNo || '';
      state.bedNo = route.query.bedNo || '';
      state.sexName = route.query.sexName || '';
      state.bedPositionName = route.query.bedPositionName || '';
      await fetchList(true);
    });

    return { state, onLoad, onRefresh, dayjsFormat, lockDays, signStatusName, checkInStatusName };
  }
});
</script>

<style lang="scss" scoped>
.checkin-records-page { background: #f5f7fa; min-height: 100vh; }
.fixed-info {
  position: sticky;
  top: 0;
  z-index: 10;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 12px;
  background: #ffffff;
  padding: 10px;
  margin: 10px 10px 0 10px;
  border-radius: 8px;
  border: 1px solid #ebedf0;
}
.fixed-info .info-item { display: flex; align-items: center; justify-content: space-between; font-size: 13px; }
.fixed-info .label { color: #909399; }
.fixed-info .value { color: #303133; font-weight: 600; }
.content { padding: 10px; }
.empty-wrap { margin-top: 40px; }
.record-card {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #ebedf0;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.row { display: flex; justify-content: space-between; align-items: center; margin: 6px 0; font-size: 13px; color: #303133; }
.row.top { margin-bottom: 8px; }
.name { font-weight: 700; color: #113050; }
.mobile { color: #606266; }
.label { color: #909399; }
.value { color: #303133; }
.value.status { font-weight: 600; }
</style>
